<template>
    <div>
        <div v-if="!splashScreenReady" style="padding: 20px">
            Загрузка..
        </div>
        <div :class="{ invisible: !splashScreenReady, showMe: splashScreenReady }" id="osp-quizz-splash">
            <div v-if="initImg != false" class="init-img-wrapper">
                <img :src="initImg" alt="" @load="whenImgLoaded">
            </div>
            <h2 id="osp-quizz-start-text" data-splitting v-html="startText"></h2>
        </div>
    </div>
</template>

<script>
// import Something from '.something'

import { gsap } from 'gsap'
import { CSSPlugin } from 'gsap/all'
// import Splitting from 'splitting'

// import {TextPlugin} from 'gsap/TextPlugin';

// var  plugins = [ CSSPlugin, AttrPlugin, TextPlugin ];

gsap.registerPlugin(CSSPlugin)

export default {

  data: function () {
    return {
      startImageLoaded: false,
      initTextLoaded: false
    }
  },
  methods: {
    whenImgLoaded () {
      this.startImageLoaded = true
    }
  },
  computed: {
    startText: function () {
      return this.$store.state.startText
    },
    initImg: function () {
      return this.$store.getters.initImg
    },
    splashScreenReady: function () {
      return this.initTextLoaded && this.startImageLoaded
    }
  },
  watch: {
    startText: function (newVal, oldVal) {
      if (newVal !== '') {
        this.initTextLoaded = true
          setTimeout(() => {
            const startButtonEl = document.getElementById('startButton')
            if (startButtonEl) {
              startButtonEl.scrollIntoView({ block: 'end', behavior: 'smooth' })
            }
          }, 1000)
        // const el = document.getElementById('osp-quizz-start-text');
        // el.innerHTML = newVal;
        // Splitting({ target: '#osp-quizz-start-text', by: 'chars'});
        //
        // document.getElementById('osp-quizz-start-text').scrollIntoView({ block: 'start', behavior: 'smooth' });
        //
        // gsap.fromTo(
        //     '#osp-quizz-start-text .char',
        //     1,
        //     {
        //         opacity: 0,
        //         x: 20,
        //     },
        //     {
        //         opacity:1,
        //         x: 0,
        //         stagger: 0.007,
        //         ease: "expo.out",
        //         onComplete: function () {
        //             let startBtn = document.getElementById('startButton');
        //             startBtn.scrollIntoView();
        //         }
        //     }
        // )
      } else {
        this.initTextLoaded = false
      }
    }
  }
}
</script>

<style lang="scss">
    #osp-quizz-start-text .char{
        opacity: 0;
        display: inline-block;
    }
    #osp-quizz-splash {
        transition: opacity 1.5s ease;
        &.invisible {
            overflow: hidden;
            height: 0px;
            opacity: 0;
        }
        &.showMe {
            height: auto;
            opacity: 1;
        }
    }
</style>
